/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable global-require */
import React, { useEffect, useState } from 'react';
import { View, TouchableOpacity, Text, StyleSheet, Image } from 'react-native';
import { doc, getDoc } from '@firebase/firestore';
import CloseIcon from '../assets/svg/CloseIcon';
import db from '../utils/db';

const styles = StyleSheet.create({
  popupContainer: {
    backgroundColor: '#000000aa',
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
  },
  popupMenu: {
    backgroundColor: '#fff',
    alignSelf: 'flex-end',
    width: 343,
    height: 607,
    marginTop: 21,
    marginRight: 29,
  },
  closeButton: {
    marginTop: 16,
    marginLeft: 300,
    marginRight: 18,
    height: 25,
    width: 25,
  },
  usernameContainer: {
    flexDirection: 'row',
    height: 60,
    marginTop: 13,
  },
  userIconPopup: {
    width: 60,
    height: 60,
    marginLeft: 25,
  },
  usernamePopup: {
    height: 22,
    width: 138,
    fontSize: 16,
    fontFamily: 'PingFangSC-Semibold',
    color: '#555559',
    marginLeft: 18,
    marginTop: 18,
    marginBottom: 20,
  },
  popupBalanceContainer: {
    width: 294,
    height: 86,
    marginRight: 25,
    marginLeft: 24,
    marginTop: 23,
    borderWidth: 2,
    borderColor: '#247a9c',
    borderStyle: 'solid',
  },
  popupBalanceText: {
    width: 115,
    height: 22,
    fontFamily: 'PingFangSC-Semibold',
    color: '#247a9c',
    fontSize: 16,
    marginLeft: 12,
    marginTop: 12,
  },
  popupBalanceValueContainer: {
    width: 173,
    height: 37,
    marginLeft: 109,
    marginTop: 3,
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  popupBalanceValue: {
    fontFamily: 'PingFangSC-Semibold',
    color: '#247a9c',
    fontSize: 26,
    alignSelf: 'flex-end',
    paddingBottom: 1,
    textAlign: 'right',
  },
  popupBalanceTWDC: {
    fontFamily: 'PingFangSC-Semibold',
    color: '#247a9c',
    fontSize: 16,
    alignSelf: 'flex-end',
    paddingBottom: 6,
  },
  menuOption: {
    backgroundColor: '#247a9c',
    height: 60,
    width: 295,
    marginLeft: 25,
    marginRight: 23,
    marginTop: 12,
  },
  menuOptionText: {
    fontFamily: 'PingFangSC-Semibold',
    fontSize: 16,
    color: '#fff',
    height: 27,
    width: 184,
    marginTop: 16,
    marginLeft: 30,
  },
});
interface Props {
  handleClosePopup: () => void;
  balanceCache: number;
  handleCache: (balance: number) => void;
}
const PopupMenu: React.FunctionComponent<Props> = ({ handleClosePopup, balanceCache, handleCache }) => {
  const [balance, setBalance] = useState(balanceCache);

  useEffect(() => {
    async function fetch() {
      const docRef = doc(db, 'user', 'user');
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        setBalance(docSnap.data().balance);
        handleCache(docSnap.data().balance);
      } else {
        // doc.data() will be undefined in this case
        // eslint-disable-next-line no-console
        console.log('No such document!');
      }
    }
    fetch();
  });
  return (
    <View style={styles.popupContainer}>
      <View style={styles.popupMenu}>
        <TouchableOpacity onPress={handleClosePopup} style={styles.closeButton}>
          <CloseIcon />
        </TouchableOpacity>
        <View style={styles.usernameContainer}>
          <Image source={{ uri: require('../assets/images/user.png') }} style={styles.userIconPopup} />
          <Text style={styles.usernamePopup}>User Name</Text>
        </View>
        <View style={styles.popupBalanceContainer}>
          <Text style={styles.popupBalanceText}>TWDC Balance</Text>
          <View style={styles.popupBalanceValueContainer}>
            <Text style={styles.popupBalanceValue}>{balance.toLocaleString('en')}</Text>
            <Text style={styles.popupBalanceTWDC}> TWDC</Text>
          </View>
        </View>
        <TouchableOpacity style={styles.menuOption}>
          <Text style={styles.menuOptionText}>Account Settings</Text>
        </TouchableOpacity>
        <TouchableOpacity style={styles.menuOption}>
          <Text style={styles.menuOptionText}>Verification</Text>
        </TouchableOpacity>
        <TouchableOpacity style={styles.menuOption}>
          <Text style={styles.menuOptionText}>Transparency</Text>
        </TouchableOpacity>
        <TouchableOpacity style={styles.menuOption}>
          <Text style={styles.menuOptionText}>My Banks</Text>
        </TouchableOpacity>
        <TouchableOpacity style={styles.menuOption}>
          <Text style={styles.menuOptionText}>Log out</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

export default React.memo(PopupMenu);
